module.exports = __webpack_public_path__ + "media/images/admin/cropping-16x9-f765b716f9a94025930ee9eab8e4e4f0.webp";